import ICustomFormSettings from "../../ICustomFormSettings";
import m, {Vnode} from "mithril";
import PointDefinition from "../../shared/components/DragDropChartBox/model/PointDefinition";
import {ImageItem} from "../../../model/items/imageItem";
import {LabelItem} from "../../../model/items/labelItem";
import {TextboxItem} from "../../../model/items/textbox";
import CustomForm from "../../CustomForm";
import PlotDefinition from "../../shared/components/DragDropChartBox/model/PlotDefinition";
import DragDropChartBox from "../../shared/components/DragDropChartBox/DragDropChartBox";

export default class DragDropChart extends CustomForm {

    private readonly dragDropChartBox: DragDropChartBox;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const points: PointDefinition[] = [];

        settings.form.grid.layout.forEach(row => {
            const [image, label, x, y] = row.map(c => c.cellItems[0]);
            if (row.length >= 4 && image instanceof ImageItem && label instanceof LabelItem && x instanceof TextboxItem && y instanceof TextboxItem) {
                points.push(new PointDefinition(image, label, x, y))
            }
        });

        let json = {};
        try {
            json = JSON.parse(settings.form.aux1 || '{}');
        } catch (e) {
            console.warn('customForm-DragDrop-chart: aux1 json invalid, use defaults');
        }

        this.dragDropChartBox = new DragDropChartBox(new PlotDefinition(json), points, settings.form);
    }


    checkRequirements(): boolean {
        if (this.dragDropChartBox.pointDefinitions.length === 0) {
            console.log('customForm-DragDrop-chart: points not found, expected rows with quadruplets - ImageItem, LabelItem, TextboxItem, TextboxItem');
            return false;
        }

        return true;
    }

    public view(): Vnode {
        return this.viewLayout( m(this.dragDropChartBox));
    }


}